/**
 * @generated SignedSource<<0c64952d57f1612b0b1478425c044dfa>>
 * @relayHash 23da067bdd715329f343ed959e89a964
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d6395fbe1c4fad28485fcf9af8bb24ab6aa8a80b64cca78d36aa60530bcd7412

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type dialogStandardTrialLimitBreakersQuery$variables = {
  cloudId: string;
  jiraApplicationKey: JiraApplicationKey;
  projectType: JiraProjectType;
  shouldIncludeIfProductIsConfluence: boolean;
  shouldIncludeIfProductIsJiraSoftware: boolean;
};
export type dialogStandardTrialLimitBreakersQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"limitBreakersModal_AtlassianEditionAwareness">;
};
export type dialogStandardTrialLimitBreakersQuery = {
  response: dialogStandardTrialLimitBreakersQuery$data;
  variables: dialogStandardTrialLimitBreakersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jiraApplicationKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldIncludeIfProductIsConfluence"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldIncludeIfProductIsJiraSoftware"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "jiraApplicationKey"
  },
  (v1/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "dialogStandardTrialLimitBreakersQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "jiraApplicationKey",
            "variableName": "jiraApplicationKey"
          },
          {
            "kind": "Variable",
            "name": "projectType",
            "variableName": "projectType"
          },
          {
            "kind": "Variable",
            "name": "shouldIncludeIfProductIsConfluence",
            "variableName": "shouldIncludeIfProductIsConfluence"
          },
          {
            "kind": "Variable",
            "name": "shouldIncludeIfProductIsJiraSoftware",
            "variableName": "shouldIncludeIfProductIsJiraSoftware"
          }
        ],
        "kind": "FragmentSpread",
        "name": "limitBreakersModal_AtlassianEditionAwareness"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dialogStandardTrialLimitBreakersQuery",
    "selections": [
      {
        "condition": "shouldIncludeIfProductIsConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v1/*: any*/)
            ],
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isUnlimited"
              },
              {
                "kind": "ScalarField",
                "name": "bytesLimit"
              }
            ]
          },
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "cql",
                "value": "type=user"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 200
              }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_searchUser",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceSearchResponse",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ConfluencePerson",
                    "kind": "LinkedField",
                    "name": "confluencePerson",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "concreteType": "Icon",
                        "kind": "LinkedField",
                        "name": "profilePicture",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "path"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldIncludeIfProductIsJiraSoftware",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "ScalarField",
                "name": "attachmentStorageAllowed"
              },
              {
                "args": (v3/*: any*/),
                "kind": "ScalarField",
                "name": "attachmentStorageIsUnlimited"
              },
              {
                "args": [
                  (v1/*: any*/),
                  {
                    "fields": [
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "types"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  }
                ],
                "concreteType": "JiraProjectConnection",
                "kind": "LinkedField",
                "name": "allJiraProjects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 20
                              }
                            ],
                            "concreteType": "JiraAssignableUsersConnection",
                            "kind": "LinkedField",
                            "name": "assignableUsers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraAssignableUsersEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                      },
                                      (v2/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      (v4/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "assignableUsers(first:20)"
                          },
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d6395fbe1c4fad28485fcf9af8bb24ab6aa8a80b64cca78d36aa60530bcd7412",
    "metadata": {},
    "name": "dialogStandardTrialLimitBreakersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c0a85cbfe1a8730ecb9b9eb0454e24d0";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
